import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  Validators,
} from '@angular/forms';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-investor-rating-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    ModalComponent,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './investor-rating-dialog.component.html',
  styleUrl: './investor-rating-dialog.component.scss',
})
export class InvestorRatingDialogComponent {
  protected understood: FormControl<boolean>;

  constructor(public activeModal: NgbActiveModal, formBuilder: FormBuilder) {
    this.understood = formBuilder.nonNullable.control(
      false,
      Validators.requiredTrue
    );
  }

  protected handlePrimaryAction(): void {
    this.understood.markAsTouched();
    if (!this.understood.valid) {
      return;
    }
    this.activeModal.close(this.understood.value);
  }

  protected handleSecondaryAction() {
    this.activeModal.dismiss('canceled');
  }
}
